import styled, { keyframes } from 'styled-components';
import { media, breakpoints } from 'utils/rwd';
import Button from '../Button/Button';
import { MODAL_SIZE } from './constants';

const fadeInAnimation = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOutAnimation = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const iconStyle = {
  height: '14px',
  verticalAlign: 'middle',
  width: '14px',
};

export const StyledCloseIcon = styled.div`
  align-self: end;
  cursor: pointer;
  display: flex;
  justify-content: end;
  padding: 8px 0;
`;

export const StyledDialog = styled.div`
  align-items: center;
  animation-duration: 600ms;
  animation-fill-mode: forwards;
  animation-name: ${({ $isFadingOut }) => ($isFadingOut ? fadeOutAnimation : fadeInAnimation)};
  animation-timing-function: ease-out;
  background: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1040;
`;

export const StyledDialogButton = styled(Button)`
  width: 100%;
  height: 48px;
`;

export const StyledDialogButtonContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-top: 32px;
  gap: 12px;
`;

export const StyledDialogButtonWrapper = styled.div`
  flex-basis: 100%;
  width: 100%;

  ${media.xs`
    display: block;
    flex-basis: auto;
    margin-top: auto;
    width: auto;
    flex: 1;
`}
`;

export const StyledDialogContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  width: 80vw;

  padding: 24px;
  position: relative;
  max-height: 85vh;
  overflow-y: auto;

  ${media.xs`
    width: auto;
    min-width: ${({ $size }) =>
      $size === MODAL_SIZE.LARGE ? '80vw' : `${0.8 * breakpoints.xs}px`};
    max-width: ${({ $size }) =>
      $size === MODAL_SIZE.LARGE ? '100vw' : `min(80vw, ${breakpoints.xs}px)`};  
  `}
`;

export const StyledDialogContent = styled.div.attrs({ className: 'mt-4' })``;

export const StyledDialogDescription = styled.h4`
  font-family: 'Cerebri Sans', sans-serif !important;
  color: #525252;
  display: block;
  text-align: center;
  font-size: 1.25rem;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.005em;
`;

export const StyledDialogHeading = styled.h2`
  font-family: 'Cerebri Sans', sans-serif !important;
  color: #120e02;
  margin-bottom: 8px;
  margin-top: 13px;
  text-align: center;
  font-size: 1.5rem;
  line-height: 32px;
  letter-spacing: 0px;
`;

export const StyledDialogBody = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${media.xs`
    width: 80%;
    margin: 0 auto;
  `}
`;

export const StyledDialogCloseButton = styled(StyledDialogButton)``;
